class EWAPBarGraphData {
  constructor(data) {
    this.data =  data.data ?? {}
    this.total = this.getTotal(data);
    this.barData = this.getBarData(this.data);
    this.barLabels_barColors = this.barLabels(this.data);
  }
  getTotal(data) {
    return data.total_employees
  }

  getBarData(data){
   let barData = Object.values(data ?? {}).map((item) => item?.['overall'])
   return barData
  }

  barLabels(data){
    let labels = Object.keys(data ?? {})
    return {labels}
  }

}


export default EWAPBarGraphData